const websiteConfigs = {
  siteName: "Wisper Energy",
  siteIcon: "ion-plus-circled",
  footerText: `Infinode Energy Mangement @ ${new Date().getFullYear()} All Rights Reserved`,
  enableAnimatedRoute: true,
  // apiUrl: "https://infinode-web-api.azurewebsites.net/api/",
  // apiUrl: "http://192.168.1.150:5050/api/",
  // apiUrl: "https://fourier.infinode.io/api/",
  apiUrl:"/api/",
  google: {
    analyticsKey: "UA-xxxxxxxxx-1"
  },
  dashboard: "/dashboard",
  isInfiDemo: true
};

export default websiteConfigs;
